module.exports = __webpack_public_path__ + "media/club/logo_30_ans-7835923b.png";